import { Spin } from 'antd';
import { connect } from 'react-redux';

import { Button, CountDown, Image, Input, MultiInput, Page } from '../../../helbest';
// store
import { _login_user } from '../../../store/actions/login_actions';
import warningImg from './../../../assets/images/icons/warning.png';
import useLogin from './useLogin';

const Footer = ({ send_code, check_code, firstPage }) => (
  <div className="page-login-footer">
    <Button onClick={() => (firstPage ? send_code() : check_code())}>
      {firstPage ? 'تایید' : 'ورود'}
    </Button>
  </div>
);

const Home = ({ Login, loginUser }) => {
  const [
    firstPage,
    setFirstPage,
    phone,
    setPhone,
    userCaptcha,
    setUserCaptcha,
    userOtp,
    setUserOtp,
    captchaImg,
    phone_error,
    set_phone_error,
    security_error,
    set_security_error,
    Recapcha,
    new_recapcha,
    send_code,
    check_code
  ] = useLogin(Login, loginUser);

  return (
    <Page
      address="/"
      back={!Login.login_required}
      className="page-login"
      footer={<Footer check_code={check_code} firstPage={firstPage} send_code={send_code} />}
      headerFix
      logo
      mobileContainer
      showFooter>
      {firstPage ? (
        <div className="login-page-form">
          <div className="login-page-form-title">شماره موبایل خود را وارد کنید</div>
          <Input
            className="mar-b-8"
            data={phone}
            dataHandler={(e) => {
              setPhone(e);
              set_phone_error(false);
            }}
            error={phone_error}
            inputMode="numeric"
            label="شماره موبایل"
            maxLength={11}
            pattern="[0-9]*"
            placeholder="۰۹*********"
          />
          <div className={`warning-container ${phone_error ? 'show' : ''}`}>
            <img alt="warining" height={20} src={warningImg} width={20} />
            <span>لطفا شماره موبایل خود را به صورت درست وارد کنید.</span>
          </div>
          <div className="login-page-form-captcha-container">
            <Input
              className="flex-stretch mar-l-10"
              data={userCaptcha}
              dataHandler={(e) => {
                setUserCaptcha(e);
                set_security_error(false);
                setUserCaptcha(e);
              }}
              inputMode="numeric"
              label="کد امنیتی"
              maxLength={4}
              pattern="[0-9]*"
              placeholder="****"
            />
            <div className="login-page-form-captcha" onClick={new_recapcha}>
              {captchaImg === '' ? (
                <Spin size="default" />
              ) : (
                <Image alt="captcha" src={captchaImg} />
              )}
            </div>
          </div>
          <div className={`warning-container mar-t-8 ${security_error ? 'show' : ''}`}>
            <img
              alt="warining"
              height={20}
              src={warningImg}
              style={{ minWidth: '20px', minHeight: '20px', marginLeft: '5px' }}
              width={20}
            />
            <span>عبارت امنیتی وارد شده صحیح نمی‌باشد.</span>
          </div>
        </div>
      ) : (
        <div className="login-page-form">
          <div className="login-page-form-title">کد تایید ارسال شده را وارد کنید</div>
          <div className="login-page-multi-input-label mar-t-60">
            <span>کد تایید به شماره موبایل</span>
            <span className="phone-number"> {phone} </span>
            <span>ارسال شد</span>
          </div>
          <MultiInput
            checkIsDigit
            className="mar-b-50"
            data={userOtp}
            dataHandler={(e) => setUserOtp(e)}
            length={6}
            maxLength={1}
          />

          <div className="page-login-otp-counter mar-b-30">
            <span className="mar-r-10">زمان باقی مانده تا ارسال مجدد کد تایید :</span>
            <CountDown
              className="page-login-counter"
              onTimeUp={() => {
                setFirstPage(true);
                setUserOtp('');
                setUserCaptcha('');
                Recapcha();
              }}
              time={180000}
            />
          </div>
          <div
            className="login-page-change-number-btn"
            onClick={() => {
              setFirstPage(true);
              setUserOtp('');
              setUserCaptcha('');
              Recapcha();
            }}>
            اصلاح شماره موبایل
          </div>
        </div>
      )}
      <div className="login-page-policy">
        <span>عضویت به معنای قبول</span>
        <a href="/faq/"> قوانین و مقررات </a>
        <span>کارفیلو است</span>
      </div>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  Login: state.Login
});

const mapDispatchToProps = (dispatch) => ({
  loginUser: (user) => dispatch(_login_user(user))
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
